'use client';

import { useTranslation } from 'next-i18next';
import { Card, ImageBj, LinkStyled } from '@components/common';
import image404 from '@images/404/img-404-page.png';

/**
 * @description Error 404 page.
 * This component displays a message indicating that the requested page was not found (404 error).
 * It provides a link to navigate back to the homepage.
 *
 */
export default function NotFound() {
  // Translation
  const { t } = useTranslation('common');

  return (
    <div className="flex grow items-center bg-surface-100">
      <div className="container mx-auto py-10">

        <Card className="rounded-md bg-surface">
          <Card.Body className="!p-10 md:!p-18">
            <div className="grid grid-cols-1 lg:grid-cols-2 lg:gap-x-8">

              {/* Column with Text & Go to homepage button */}
              <div className="order-2 lg:order-1">
                <h1 className="text-5xl font-light tracking-tight sm:text-6xl">{ t('error.404.title') }</h1>
                <h1 className="mt-6 text-5xl font-bold tracking-tight text-ink-medium sm:text-6xl">404</h1>
                <p className="mt-6 font-semibold text-ink">{ t('error.404.react.subtitle') }</p>
                <p className="mt-6 text-ink-medium">{ t('error.404.desc') }</p>
                <div className="mt-8">
                  <LinkStyled href="/" color="secondary">
                    {t('error.bt.get_out')}
                  </LinkStyled>
                </div>
              </div>

              {/* Column with Image */}
              <div className="order-1 mb-10 lg:order-2">
                <ImageBj src={image404} alt="Error 404 image" />
              </div>

            </div>
          </Card.Body>
        </Card>

      </div>
    </div>
  );
}
